"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBApiConsumerCard", {
  enumerable: true,
  get: function get() {
    return _SVBApiConsumerCard.default;
  }
});
var _SVBApiConsumerCard = _interopRequireDefault(require("./src/SVBApiConsumerCard"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }